import { http } from '@/network';
import type { IHttpService, HttpConfig } from '../interfaces/http.interface';

function axiosConfig(config?: HttpConfig) {
  if (!config) return undefined;
  return {
    params: config.params,
    headers: config.headers,
  };
}

export class HttpService implements IHttpService {
  async get<T>(url: string, params?: Record<string, unknown>): Promise<T> {
    return http.get<T>(url, params ? { params } : undefined);
  }

  async post<T>(url: string, data?: unknown, config?: HttpConfig): Promise<T> {
    return http.post<T>(url, data, axiosConfig(config));
  }

  async put<T>(url: string, data?: unknown, config?: HttpConfig): Promise<T> {
    return http.put<T>(url, data, axiosConfig(config));
  }

  async patch<T>(url: string, data?: unknown, config?: HttpConfig): Promise<T> {
    return http.patch<T>(url, data, axiosConfig(config));
  }

  async delete<T>(url: string, config?: HttpConfig): Promise<T> {
    return http.delete<T>(url, axiosConfig(config));
  }
}
